import { Skeleton } from '@mui/material';
import { styled as muiStyled, css, useTheme } from '@mui/material/styles';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import SmallForm from './small-form';
import Button from '../base/button';
import Text from '../base/text';

import Arranger from '~c/components/base/arranger';
import LogoSelector from '~c/components/base/icon/logo-selector';
import Spacer, { spc } from '~c/components/base/spacer';
import { nodeAuthApi } from '~c/services';
interface Props {
  className?: string;
}

const UserEmailVerificationImpl: React.FC<Props> = ({ className }) => {
  const navigate = useNavigate();
  const { code } = useParams();
  const [messages, setMessages] = React.useState<string>('');
  const [isSuccess, setIsSuccess] = React.useState<boolean>(false);
  const theme = useTheme();
  const prefersDarkMode = theme.palette.mode === 'dark';
  const [sendEmailVerification, { isLoading }] =
    nodeAuthApi.useEmailVerifyMutation();

  const verifyUser = async () => {
    await sendEmailVerification({
      emailVerifiedId: code ?? '',
    })
      .then((resp: any) => {
        if ('data' in resp && !('error' in resp?.data)) {
          setMessages(
            `Your email account ${resp.data.email} have been verified successfully`
          );
          setIsSuccess(true);
        } else {
          setMessages(resp.error.data.error);
          setIsSuccess(false);
        }
      })
      .catch(() => {
        // handle error
        setIsSuccess(false);
      });
  };

  const handleSignInRedirect = () => {
    navigate('/sign-in');
  };

  useEffect(() => {
    verifyUser();
  }, []);

  if (isLoading) {
    return (
      <SmallForm className={className}>
        <Arranger
          direction="column"
          alignItems="center"
          sx={{ pt: spc.between_vertical_l, pb: spc.between_vertical_l }}
        >
          {/* Logo skeleton */}
          <Arranger
            direction="column"
            alignItems="center"
            sx={{ pb: spc.between_vertical_m }}
          >
            <Skeleton variant="rectangular" width={120} height={36} />
          </Arranger>

          {/* Message skeleton */}
          <Skeleton variant="text" width="80%" height={32} />
          <Spacer pb={spc.xs} />
          <Skeleton variant="text" width="60%" height={24} />

          <Spacer pb={spc.m} />

          {/* Button skeleton */}
          <Skeleton variant="rounded" width={140} height={48} />
        </Arranger>
      </SmallForm>
    );
  }
  return (
    <>
      {messages ? (
        <SmallForm className={className}>
          <Arranger
            direction="column"
            alignItems="center"
            sx={{ pt: spc.between_vertical_l, pb: spc.between_vertical_l }}
          >
            <Arranger
              direction="column"
              alignItems="center"
              sx={{ pb: spc.between_vertical_m }}
            >
              <div className="logo-container">
                <LogoSelector prefersDarkMode={prefersDarkMode} />
              </div>
            </Arranger>
            <Text sz="title" align="center">
              {messages}
            </Text>
            <Spacer pb={spc.m} />
            <Button onClick={handleSignInRedirect}>Go to Sign In</Button>
          </Arranger>
        </SmallForm>
      ) : (
        <></>
      )}
    </>
  );
};

export const UserEmailVerification = muiStyled(UserEmailVerificationImpl)(
  ({ theme }) => css`
    .logo-container {
      svg {
        width: 150px;
        height: 50px;
      }
    }
  `
);

export default UserEmailVerification;
